import React from 'react';
import { motion } from 'framer-motion';
export function MomAndChild({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative w-full max-w-md mx-auto aspect-square ${className}`} data-id="element-77">
      {/* Background blobs */}
      <div className="absolute inset-0 bg-pastel-blueLight rounded-[40px] rotate-3 scale-95" data-id="element-78" />
      <div className="absolute inset-0 bg-pastel-mintLight rounded-[40px] -rotate-3 scale-95" data-id="element-79" />

      <svg viewBox="0 0 400 400" className="w-full h-full relative z-10 drop-shadow-xl" data-id="element-80">
        {/* Desk */}
        <path d="M 40 320 L 360 320 L 380 400 L 20 400 Z" fill="#F0F4F8" data-id="element-81" />
        <path d="M 40 320 L 360 320 L 360 340 L 40 340 Z" fill="#E2E8F0" data-id="element-82" />

        {/* Notebook on desk */}
        <rect x="140" y="300" width="120" height="40" rx="4" fill="#FFFFFF" transform="rotate(-5 200 320)" data-id="element-83" />
        <rect x="150" y="310" width="40" height="4" rx="2" fill="#BFE3F5" transform="rotate(-5 200 320)" data-id="element-84" />
        <rect x="150" y="320" width="60" height="4" rx="2" fill="#BFE3F5" transform="rotate(-5 200 320)" data-id="element-85" />

        {/* Mom */}
        <g transform="translate(80, 120)" data-id="element-86">
          {/* Body */}
          <path d="M 30 200 C 30 150, 110 150, 110 200 L 110 220 L 30 220 Z" fill="#CDB9F2" data-id="element-87" />
          {/* Neck */}
          <rect x="60" y="100" width="20" height="30" fill="#FFDDBB" data-id="element-88" />
          {/* Head */}
          <circle cx="70" cy="80" r="35" fill="#FFDDBB" data-id="element-89" />
          {/* Hair */}
          <path d="M 30 80 C 30 30, 110 30, 110 80 C 110 120, 90 140, 90 140 L 50 140 C 50 140, 30 120, 30 80 Z" fill="#4A3E3D" data-id="element-90" />
          {/* Face details */}
          <circle cx="85" cy="80" r="4" fill="#4A3E3D" data-id="element-91" />
          <path d="M 80 95 Q 90 105 100 95" fill="none" stroke="#4A3E3D" strokeWidth="3" strokeLinecap="round" data-id="element-92" />
          {/* Arm pointing */}
          <path d="M 90 160 Q 140 180 160 210" fill="none" stroke="#FFDDBB" strokeWidth="16" strokeLinecap="round" data-id="element-93" />
        </g>

        {/* Child */}
        <g transform="translate(200, 160)" data-id="element-94">
          {/* Body */}
          <path d="M 20 160 C 20 120, 80 120, 80 160 L 80 180 L 20 180 Z" fill="#FFE9A3" data-id="element-95" />
          {/* Neck */}
          <rect x="40" y="70" width="16" height="20" fill="#FFDDBB" data-id="element-96" />
          {/* Head */}
          <circle cx="48" cy="50" r="30" fill="#FFDDBB" data-id="element-97" />
          {/* Hair */}
          <path d="M 18 50 C 18 10, 78 10, 78 50 C 78 60, 68 70, 68 70 L 28 70 C 28 70, 18 60, 18 50 Z" fill="#8B5A2B" data-id="element-98" />
          {/* Face details */}
          <circle cx="35" cy="50" r="3" fill="#4A3E3D" data-id="element-99" />
          <circle cx="60" cy="50" r="3" fill="#4A3E3D" data-id="element-100" />
          <path d="M 40 65 Q 48 75 55 65" fill="none" stroke="#4A3E3D" strokeWidth="3" strokeLinecap="round" data-id="element-101" />
          {/* Arm writing */}
          <path d="M 30 130 Q 0 150 -20 160" fill="none" stroke="#FFDDBB" strokeWidth="14" strokeLinecap="round" data-id="element-102" />
        </g>

        {/* Floating elements */}
        <motion.g animate={{
        y: [-5, 5, -5]
      }} transition={{
        duration: 3,
        repeat: Infinity
      }} data-id="element-103">
          <path d="M 320 100 L 330 130 L 360 130 L 335 150 L 345 180 L 320 160 L 295 180 L 305 150 L 280 130 L 310 130 Z" fill="#FFE9A3" data-id="element-104" />
        </motion.g>
        <motion.g animate={{
        y: [5, -5, 5]
      }} transition={{
        duration: 4,
        repeat: Infinity
      }} data-id="element-105">
          <circle cx="80" cy="60" r="15" fill="#BFE3C4" data-id="element-106" />
          <path d="M 75 55 L 85 65 M 85 55 L 75 65" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" data-id="element-107" />
        </motion.g>
      </svg>
    </div>;
}